/**
 * Linked option dropdowns: always keep flavour/option values visible.
 * Values with no quantity (variant.available === false) stay in the list
 * and are labelled "Unavailable - ".
 * Uses variant.available (inventory_quantity is not always in storefront JSON).
 */
(function() {
  var Shopify = window.Shopify = window.Shopify || {};
  var PREFIX = 'Unavailable - ';

  Shopify.variantHasInventory = function(variant) {
    return !!variant.available;
  };

  function getOptionSelector(optIdx) {
    var selector = document.getElementById('SingleOptionSelector-' + optIdx);
    if (!selector) {
      selector = document.querySelector('.single-option-selector[data-index="option' + (optIdx + 1) + '"]');
    }
    return selector;
  }

  function selectedPriorOptions(optIdx) {
    var selectedPrior = {};
    for (var p = 0; p < optIdx; p++) {
      var prevSel = getOptionSelector(p);
      if (prevSel) {
        selectedPrior[p + 1] = prevSel.value;
      }
    }
    return selectedPrior;
  }

  function optionValuesForSelector(product, optIdx, selectedPrior) {
    var stockByValue = {};
    var order = [];
    var optKey = 'option' + (optIdx + 1);

    product.variants.forEach(function(variant) {
      var val = variant[optKey];
      if (!val) {
        return;
      }
      for (var key in selectedPrior) {
        if (selectedPrior.hasOwnProperty(key) && variant['option' + parseInt(key, 10)] !== selectedPrior[key]) {
          return;
        }
      }
      if (!Object.prototype.hasOwnProperty.call(stockByValue, val)) {
        stockByValue[val] = false;
        order.push(val);
      }
      if (Shopify.variantHasInventory(variant)) {
        stockByValue[val] = true;
      }
    });

    return { order: order, stockByValue: stockByValue };
  }

  function optionSignature(selector) {
    return Array.prototype.map.call(selector.options, function(opt) {
      return opt.value + ':' + (opt.getAttribute('data-has-stock') === 'true' ? '1' : '0');
    }).join('|');
  }

  Shopify.markUnavailableOptionLabels = function(product) {
    if (!product || !product.variants || !product.variants.length || !product.options || !product.options.length) {
      return;
    }
    if (Shopify._unavailablePass > 3) {
      return;
    }
    Shopify._unavailablePass = (Shopify._unavailablePass || 0) + 1;

    try {
      for (var optIdx = 0; optIdx < product.options.length; optIdx++) {
        var selector = getOptionSelector(optIdx);
        if (!selector || selector.tagName !== 'SELECT') {
          continue;
        }

        var selectedPrior = selectedPriorOptions(optIdx);
        var mapped = optionValuesForSelector(product, optIdx, selectedPrior);
        var currentValue = selector.value;
        var visible = [];
        var nextValue = '';

        mapped.order.forEach(function(val) {
          var hasStock = mapped.stockByValue[val] === true;
          visible.push({ value: val, hasStock: hasStock });
          if (!nextValue) {
            nextValue = val;
          }
          if (val === currentValue) {
            nextValue = val;
          }
        });

        if (!visible.length) {
          continue;
        }

        var nextSig = visible.map(function(item) {
          return item.value + ':' + (item.hasStock ? '1' : '0');
        }).join('|');

        if (optionSignature(selector) !== nextSig) {
          selector.innerHTML = '';
          visible.forEach(function(item) {
            var opt = document.createElement('option');
            opt.value = item.value;
            opt.setAttribute('data-option-value', item.value);
            opt.setAttribute('data-has-stock', item.hasStock ? 'true' : 'false');
            opt.textContent = item.hasStock ? item.value : PREFIX + item.value;
            if (item.value === nextValue) {
              opt.selected = true;
            }
            selector.appendChild(opt);
          });
        } else {
          Array.prototype.forEach.call(selector.options, function(opt) {
            var hasStock = opt.getAttribute('data-has-stock') === 'true';
            var raw = opt.getAttribute('data-option-value') || opt.value;
            opt.disabled = false;
            opt.textContent = hasStock ? raw : PREFIX + raw;
          });
        }
      }
    } finally {
      Shopify._unavailablePass -= 1;
    }
  };
})();
